<template>
  <LoadingScreen v-model="loading" />
  <Transition name="fade">
    <div ref="pform" class="pform" :class="{ 'pform_transition': transition }" v-show="show">
      <div class="pform__slide" :class="{ 'pform__slide_shifted': step == 2 }">
        <div class="pform__inner">
          <form @submit.stop.prevent class="pform__window" ref="window" id="pform-form">
            <div ref="stepwindow" class="pform__stepwindow" :style="{ 'transform': `translateX(${(step - 1) * 100 * (-1)}%)` }">
              <Step1 :active="step == 1" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </Transition>
  <ThanksPopup />
  <ErrorPopup />
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import LoadingScreen from './components/LoadingScreen.vue';
import Step1 from './components/steps/Step1.vue';
import ThanksPopup from './components/ThanksPopup.vue';
import ErrorPopup from './components/ErrorPopup.vue';

export default {
  name: 'App',
  components: { LoadingScreen, Step1, ThanksPopup, ErrorPopup },

  computed: {
    ...mapState(['step', 'show', 'form']),
    ...mapGetters(['loading'])
  },
  methods: {

  },
  data: () => ({
    transition: false,
    timer: undefined
  }),
  watch: {
    step(v, old) {
      if (!v != old) {
        clearTimeout(this.timer)
        this.transition = true
        this.timer = setTimeout(() => this.transition = false, 400)
      }
    },
    show(v,old) {
      if (v != old && !v) {
        const section = document.querySelector('.formsection')
        section.style.setProperty('height', section.offsetHeight + 'px')
        section.style.setProperty('overflow', 'hidden')
        section.style.setProperty('transition', 'height 1s ease, padding 1s ease')
        window.requestAnimationFrame(()=>{
          section.style.setProperty('height', '0px')
          section.style.setProperty('padding', '0px')
        })
      }
    }
  },
  beforeMount(){
    let defaults = document.querySelector('#app').getAttribute('data-data')
    if (defaults) {
      defaults = JSON.parse(defaults)
      for (let key of ['id','name','bank','tel','email','date']) {
        if (defaults[key]) {
          this.form.step1[key] = (defaults[key] + '')
        }
      }
    }
  },
  mounted() {
    let v = this.$store.state.version
    window.document.body.addEventListener('click', (e) => {
      if (!e.isTrusted) return
      if (!e.target.classList.contains('tooltip') && !e.target.closest('.tooltip')) {
        //eslint-disable-next-line
        qall('.tooltip__body.active').forEach(el=>el.classList.remove('active'))
      }
    })
    if (v) {
      let el = document.createElement('div')
      el.classList.add('pform-version')
      el.innerHTML = v
      document.body.append(el)
    }
    window.addEventListener('load', () => {
      window.initTooltips(this.$refs.pform)
    })
  },
}
</script>

<style lang="sass">
.pform-version
  position: fixed
  z-index: 2147000000
  bottom: 10px
  left: 10px
  padding: 5px 10px
  background: white
  color: black
  font-weight: 700
  font-size: 12px
  border-radius: 20px
  opacity: .5
  border: 1px solid rgba(0,0,0,.5)
  font-family: 'Muller', sans-serif
.fade-enter-from,.fade-leave-to, .fastfade-enter-from,.fastfade-leave-to
  opacity: 0
  pointer-events: none
.fastfade-enter-active,.fastfade-leave-active
  transition: opacity .2s ease-out
.fade-enter-active,.fade-leave-active
  transition: background .5s ease, opacity .4s ease-out
.nowrap
  white-space: nowrap
.mobdisappear
  @include for-mob
    display: none
#app
  flex-grow: 1

.pform
  /*
    --headeroffset: 79px
    @include from(1135px)
      --headeroffset: 134px
    @include for-mob
      --headeroffset: 64px
  --headeroffset: 0px
  padding: 50px 16px
  width: 100%
  
  &_transition
    overflow: hidden

  color: colors.$gray5
  background: colors.$mainbg
  transition: background .5s ease, opacity .4s ease-out
  display: flex
  *
    font-family: globalvars.$font6
    letter-spacing: globalvars.$onespacing
  .newred
    color: colors.$newred !important
  &__slide
    width: 100%
    flex-shrink: 0
    transition: transform .6s ease-out
    &_shifted
      transform: translateX(-100%)
  img, svg
    display: block
  &__dot
    margin: 40px auto 50px
    width: 22px
    height: 22px
    border-radius: 99px
    background: colors.$moar_silver_for_the_god_of_silver2
    @include for-mob
      display: none
  & &__title
    font-weight: 500
    font-size: 36px
    line-height: 1.12
    margin: 0
    color: colors.$bluefont
    text-align: center
    transition: margin-bottom .4s ease-out
    @include for-med
      font-size: 28px
      line-height: 1.12

    &_smspace
      margin-bottom: 24px
    &_nospace
      margin-bottom: 0px
  &__subtitle
    font-size: 24px
    line-height: 1.16
    margin-bottom: 8px
    color: colors.$gray3
    text-align: center
  .wrapper-section
    margin: 0 auto
    max-width: globalvars.$wrapper-width

    @include from(globalvars.$tablet)
      width: globalvars.$wrapper-tablet
      max-width: 100%
      min-width: 0
    @include for-mob
      width: globalvars.$wrapper-mob
  .onlydesk
    @include for-mob
      display: none !important
  .onlymob
    @include since(768px)
      display: none !important
  .onlynano
    @include since(450px)
      display: none !important
  &__inner
    width: 900px
    max-width: 100%
    margin: 0 auto
    align-items: center
    display: flex
    flex-direction: column
  &__window
    width: 100%
    margin: 32px auto
  &__stepwindow
    display: flex
    width: 100%
    transition: transform .5s ease  
    >*
      width: 100%
      flex-shrink: 0
  *, &::before, &::after
    letter-spacing: var(--normspacing, .01em)
  &__specialtext
    margin-right: -5px
    font-size: 12px
    line-height: 1.18
  @include for-mob
    padding: 0px
    &__window
      margin: 0
    & &__title
      font-weight: 700
      font-size: 18px
      text-align: left
      margin: 0 0 44px
      &_smspace
        margin-bottom: 24px
    .tooltip__body
      border-radius: 16px

</style>
